import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { PartnerBlockUnblock, ReferralActionResponse } from 'types/api'
import { BaseParams } from 'types/utils'

export function useBlockPartnerReferrals() {
  const queryClient = useQueryClient()

  async function blockPartnerReferrals({
    id,
    body
  }: BaseParams<[PartnerBlockUnblock, ReferralActionResponse], 'POST'>) {
    const response = await apiClient.post<ReferralActionResponse>(
      SNA_PREFIX + `partners/${id}/block`,
      body
    )
    return response.data
  }

  return useMutation({
    mutationFn: blockPartnerReferrals,
    onSuccess: (data, variables) => {
      variables.params?.onSuccess?.(data)
      // Invalidate queries to refresh data
      queryClient.invalidateQueries({ queryKey: ['partners'] })
      queryClient.invalidateQueries({ queryKey: ['referrals'] })
    },
    onError: (_, variables) => {
      variables.params?.onError?.()
    }
  })
}
